<section class="relative bg-gradient-to-br from-gray-50 to-blue-50 py-20 px-6 overflow-hidden">
  <div class="max-w-7xl mx-auto">
    <div class="flex flex-col lg:flex-row items-center justify-between gap-12">

      <div class="w-full lg:w-1/2 space-y-6 text-center lg:text-left">
        <div class="inline-block px-4 py-1.5 bg-blue-100 text-blue-700 rounded-full text-sm font-bold tracking-wide uppercase">
          স্মার্ট স্কুল ম্যানেজমেন্ট সলিউশন
        </div>

        <h1 class="text-4xl md:text-5xl lg:text-6xl font-black text-slate-900 leading-tight">
          আপনার শিক্ষাপ্রতিষ্ঠানকে করুন <span class="text-blue-600">ডিজিটাল ও স্মার্ট</span>
        </h1>

        <p class="text-lg text-slate-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
          <span class="font-bold text-slate-800">MentorERP</span> একটি পূর্ণাঙ্গ স্কুল ম্যানেজমেন্ট সফটওয়্যার। ভর্তি থেকে রেজাল্ট, বেতন থেকে অটোমেটেড এসএমএস—সবকিছুই এখন আপনার হাতের মুঠোয়। ডিজিটাল বাংলাদেশ গড়ার লক্ষ্যে আমরা নিয়ে এসেছি আধুনিক শিক্ষা ব্যবস্থার সেরা সমাধান।
        </p>

      </div>

      <div class="w-full lg:w-1/2 relative">
        <div class="absolute -top-10 -right-10 w-64 h-64 bg-blue-200 rounded-full blur-3xl opacity-30"></div>
        <div class="absolute -bottom-10 -left-10 w-64 h-64 bg-indigo-200 rounded-full blur-3xl opacity-30"></div>

        <div class="relative z-10 group">
          <img ngSrc="contact.webp" alt="Software Dashboard Preview" width="600" height="450"
            class="w-full h-auto block object-cover transform transition-transform duration-700 group-hover:scale-105 animate-float">

          <div class="absolute -bottom-6 -left-6 bg-white p-4 rounded-lg shadow-xl hidden md:flex items-center space-x-3 border border-slate-100 animate-bounce-slow">
            <div class="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center text-white">
              <i class="fas fa-check"></i>
            </div>
            <div>
              <p class="text-xs text-slate-500">স্বয়ংক্রিয়</p>
              <p class="text-sm font-bold text-slate-800">রেজাল্ট পাবলিশিং</p>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>

